<span [class]="classnames" [ngStyle]="styles">
  <app-icon *ngIf="icon" [name]="icon" [size]="variant === 'slim' ? 'inherit' : 'tiny'" class="me-1"></app-icon>
  <div *ngIf="svgIcon" class="me-1" [innerHtml]="svgIcon | safeHtml"></div>
  {{ label }}
</span>
